import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { graphql } from 'app/generated/gql'
import { gqlQuery } from 'app/lib/graphqlClient'
import { opsClient } from 'app/lib/opsUrqlClient'
import { legacyRoleRank } from 'app/types/roles'
import { logError } from 'lib/logging'

const USER_ACTIVITY_QUERY = graphql(`
  query UserActivity($userId: ID!) {
    userActivity(userId: $userId) {
      activities {
        action
        dateTime
        email
        role
      }
    }
  }
`)

export type ActivityRow = {
  action: string
  dateTime: string
  email: string
  role: string
}

export type UseUserActivityReturn = {
  activities: ActivityRow[]
}

export function useUserActivity(): UseUserActivityReturn {
  const { userId } = useParams()
  const [activities, setActivities] = useState<ActivityRow[]>([])

  useEffect(() => {
    if (!userId) return
    gqlQuery<{ userActivity: { activities: { action: string; dateTime: string; email: string; role: string }[] } }>(
      USER_ACTIVITY_QUERY,
      { userId },
      { client: opsClient },
    )
      .then((result) => {
        const activities = result.data?.userActivity?.activities ?? []
        setActivities(
          activities.map((a) => ({
            action: a.action || ``,
            dateTime: a.dateTime || ``,
            email: a.email || ``,
            role: a.role ? legacyRoleRank[a.role] || `` : ``,
          })),
        )
      })
      .catch((err) => logError(`Error fetching user activity`, err))
  }, [userId])

  return { activities }
}
